import { Tooltip } from 'antd';
import { Box } from '@mui/material';
import CloseIcon from 'assets/icons/reject';

const ExitButton = ({ handleClose, color = '#ffde21' }) => {
	return (
		<Tooltip title="Exit">
			<Box
				onClick={handleClose}
				sx={{
					width: '22px',
					height: '22px',
					display: 'flex',
					cursor: 'pointer',
					borderRadius: '4px',
					alignItems: 'center',
					transition: 'all 0.3s',
					justifyContent: 'center',

					'&:hover': {
						transform: 'scale(1.2)',
					},
				}}
			>
				<CloseIcon color={color} width="22px" height="22px" />
			</Box>
		</Tooltip>
	);
};

export default ExitButton;
